import sample from 'lodash/sample';
import sampleSize from 'lodash/sampleSize';
import intersection from 'lodash/intersection';
import { PostType } from '@/components/home-page/RecommendPost';
import {
  PRODUCTION_HOST,
  PRODUCTION_ENVIRONMENT,
} from '@/constants/router-path';
import { getArticles, getArticleTags, getArticlesByTags } from '@/api/tanzhi';

export const getJobTitlePagePosts = async (jobTitle: any) => {
  const arrTagsId: string[][] = [[], [], [], []];
  const tagsResponse = await getArticleTags();
  const tags = tagsResponse.status === 200 ? tagsResponse.data : [];
  tags.map((tag: { id: string; name: string }) => {
    if (jobTitle?.name === tag.name) {
      arrTagsId[0].push(tag.id);
      return;
    }
    const tagIndex = jobTitle?.l1_l2_list?.findIndex(
      (jobTitle: any) => jobTitle.name === tag.name,
    );
    if (tagIndex >= 0) {
      arrTagsId[0].push(tag.id);
    }
    if (tag.name === '简历建议') {
      arrTagsId[1].push(tag.id);
    }
    if (tag.name === '求职') {
      arrTagsId[2].push(tag.id);
    }
    if (tag.name === '团队文化') {
      arrTagsId[3].push(tag.id);
    }
  });
  const arrTagsFirstId = [...arrTagsId[0]];
  if (arrTagsFirstId.length > 0) {
    const sampleId = sample(arrTagsFirstId);
    sampleId && arrTagsId.splice(0, 1, [sampleId]);
  }
  const tagIds = arrTagsId.flat();
  const response = await Promise.all(tagIds.map((id) => getArticlesByTags(id)));
  const articles: PostType[][] = await Promise.all(
    response.map((item) => (item.status === 200 ? item.data : [])),
  );
  const posts: PostType[] = [];
  articles.forEach((item) => {
    if (item.length > 0) {
      const samplePost = sample(item);
      samplePost && posts.push(samplePost);
    }
  });
  return posts.slice(0, 3);
};

export const getCityPagePosts = async () => {
  if (process.env.ENVIRONMENT !== PRODUCTION_ENVIRONMENT) return [];

  const articleTagsResponse = await getArticleTags();
  const tags =
    articleTagsResponse.status === 200 ? articleTagsResponse.data : [];
  const arrTagsId: string[][] = [[], []];
  tags.map((item: any) => {
    if (item.name === '求职') {
      arrTagsId[0].push(item.id);
    }
    if (item.name === '团队文化') {
      arrTagsId[1].push(item.id);
    }
  });
  const arrPosts: PostType[][] = [[], []];
  const tagsIds = arrTagsId.map((innerArray) => innerArray.join(',')).join(',');
  const articlesResponse = await getArticlesByTags(tagsIds);
  const articles = articlesResponse.status === 200 ? articlesResponse.data : [];
  articles.forEach((article: any) => {
    const idx = arrTagsId.findIndex(
      (item) => intersection(item, article.tags).length > 0,
    );
    if (idx >= 0) {
      arrPosts[idx].push(article);
    }
  });

  const posts: PostType[] = [];
  arrPosts.forEach((item, index) => {
    const samplePost = sampleSize(item, index + 1);
    samplePost && posts.push(...samplePost);
  });
  return posts;
};

export const getHomePagePosts = async () => {
  if (window.location.host !== PRODUCTION_HOST) return [];

  const response = await getArticles();
  if (response.status === 200) {
    return sampleSize(response.data, 3);
  }
  return [];
};
